/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* makerCheckerWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.SUBMIT_FORCE_REFUND_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.GET_FORCE_REFUND_REQUESTS, workerSaga);
  yield takeLatest(ActionConstants.GET_FORCE_REFUND_REQUEST_DETAILS, workerSaga);
  yield takeLatest(ActionConstants.APPROVE_FORCE_REFUND_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.REJECT_FORCE_REFUND_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.GET_FORCE_REFUND_EXECUTION_STATUS, workerSaga);
  yield takeLatest(ActionConstants.SUBMIT_FORCE_UPDATE_ORDER_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.GET_FORCE_UPDATE_ORDER_REQUESTS, workerSaga);
  yield takeLatest(ActionConstants.GET_FORCE_UPDATE_ORDER_REQUEST_DETAILS, workerSaga);
  yield takeLatest(ActionConstants.APPROVE_FORCE_UPDATE_ORDER_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.REJECT_FORCE_UPDATE_ORDER_REQUEST, workerSaga);
  yield takeLatest(ActionConstants.GET_FORCE_UPDATE_ORDER_EXECUTION_STATUS, workerSaga);
}
